import { timeFormat } from '~/app/utils/timeFormat'
import { DateTime } from 'luxon'

const periodEndTime = ({ expectedArriveAt, departureDate }) => {
  const departure = DateTime.fromFormat(departureDate, 'yyyy-MM-dd')
  const time = DateTime.fromISO(expectedArriveAt).toFormat('HH:mm')
  const isDiffDays = DateTime.fromISO(expectedArriveAt).diff(departure, 'day').days >= 1
  return timeFormat(time, isDiffDays)
}

export default periodEndTime
